function SvgTranslate(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 38 37"
      {...props}
    >
      <path d="M11.198 12.057a.638.638 0 00.57-1.142 10.306 10.306 0 01-1.816-1.17 7.997 7.997 0 001.394-2.728h.775a.638.638 0 000-1.276H9.569v-.638a.638.638 0 10-1.276 0v.638H5.741a.638.638 0 100 1.276h4.268a6.63 6.63 0 01-1.014 1.87 7.955 7.955 0 01-.812-.949.638.638 0 00-1.06.71c.293.413.622.801.983 1.158a5.902 5.902 0 01-1.93 1.071.639.639 0 10.403 1.212c.914-.299 1.759-.78 2.483-1.413.66.537 1.375 1 2.136 1.38z" />
      <path d="M17.192 8.931h9.641a1.876 1.876 0 011.874 1.874v5.781l-.766-1.02a.638.638 0 00-1.02.765l1.913 2.552a.638.638 0 001.149-.383v-7.695a3.153 3.153 0 00-3.15-3.15h-9.641a8.293 8.293 0 100 1.276zM1.914 8.293A7.017 7.017 0 118.93 15.31a7.026 7.026 0 01-7.017-7.017zm27.43 12.12a8.299 8.299 0 00-8.26 7.656h-9.64a1.876 1.876 0 01-1.875-1.874v-5.781l.765 1.02a.638.638 0 001.021-.765l-1.914-2.552a.638.638 0 00-1.148.383v7.695a3.153 3.153 0 003.15 3.15h9.641a8.29 8.29 0 108.26-8.931zm0 15.311a7.017 7.017 0 117.018-7.017 7.026 7.026 0 01-7.017 7.017z" />
      <path d="M29.919 25.232a.665.665 0 00-1.142 0l-3.19 6.38a.638.638 0 101.142.57l2.616-5.238 1.2 2.4h-1.2a.638.638 0 100 1.277h1.838l.78 1.56a.638.638 0 101.142-.57l-3.186-6.379z" />
    </svg>
  );
}

export default SvgTranslate;
